import { render, staticRenderFns } from "./ANewArea.vue?vue&type=template&id=ddd84c70"
import script from "./ANewArea.vue?vue&type=script&lang=js"
export * from "./ANewArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports